﻿$.fn.dxCtrlFichier2Resume = function custom_dxCtrlFichier2Resume(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2resume dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Resume(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Resume = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.typeVisu == 'undefined') option.typeVisu = "tag"

    var $DivLstFiles = null
    var dxBtAddFile = null
    function mConstruit() {
        container.empty()
        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:0px;vertical-align:top;'/>").appendTo($Tr)
        if (typeof option.containerBtAdd == 'undefined' || option.containerBtAdd == null) option.containerBtAdd = $Td
        if (!option.readOnly && typeof option.onAddFiles != 'undefined') {
            option.containerBtAdd.empty()
            dxBtAddFile = $("<div/>").appendTo(option.containerBtAdd).dxCtrlButton({
                //height: 40,
                //width: 40,
                icon: "fas fa-paperclip",
                icon2: "fas fa-plus",
                colorIcone2: theme.colorBtIcon2,
                txtTooltip: "Ajouter des fichiers",
                onClick: function (e) {
                    e.event.stopPropagation()
                    mGetNewFiles(function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            option.onAddFiles(lstUrlFile, function (lstNewItemData) {
                                dxCtrlTagGallery.mAddNewItemData(lstNewItemData)
                            })
                        }
                    })
                }
            }).dxCtrlButton("instance")
        }


        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $DivLstFiles = $("<div/>").appendTo($Td)
        if (!parametre.isMobile && option.typeVisu != "lst") {
            $DivLstFiles.addClass("state-hover")
            $DivLstFiles.off("click")
            $DivLstFiles.on("click", function (e) {
                e.stopPropagation()
                Me.mShowVisu(null)
            })
        }

        mRempli()
    }

    var dxCtrlTagGallery = null
    function mRempli() {
        $DivLstFiles.css("height", (($DivLstFiles.innerHeight() == 0) ? "" : $DivLstFiles.innerHeight() + "px"))
        $DivLstFiles.empty()

        switch (option.typeVisu) {
            case "tag":
                dxCtrlTagGallery = $("<div/>").appendTo($DivLstFiles).dxCtrlFichier2Tag({
                    bddCtrl: option.bddCtrl,
                    readOnly: option.readOnly,
                    dataSource: option.dataSource,
                    allowReorder: option.allowReorder,
                    onDeleteFiles: function (lstItemDataToDel,funcEnd) {
                        option.onDeleteFiles(lstItemDataToDel,funcEnd)
                        mUpdataModifLstFile()
                    },
                    onClickFile: function (itemData) {
                        //if (isInAppMobile()) {
                        //    //on est dans une applivation mobile
                        //    //on télécharge directement les fichiers
                        //    var url = itemData.url
                        //    if (url.startsWith("~")) url = url.substring(1)
                        //    //window.open(url, "_blank")
                        //    mDownLoadFile(url)
                        //} else {
                        if (option.downloadFile) {
                            var url = itemData.url
                            if (url.startsWith("~")) url = url.substring(1)
                            //window.open(url, "_blank")
                            mDownLoadFile(option.bddCtrl, url)
                        }
                        else { Me.mShowVisu(itemData) }
                        //}
                    }
                }).dxCtrlFichier2Tag("instance")
                break;
            case "gallery":
                dxCtrlTagGallery = $("<div/>").appendTo($DivLstFiles).dxCtrlFichier2Gallery({
                    bddCtrl: option.bddCtrl,
                    readOnly: option.readOnly,
                    dataSource: option.dataSource,
                }).dxCtrlFichier2Gallery("instance")
                break;
            case "lst":
                if (typeof option.widthVignette == 'undefined') option.widthVignette = "100"
                option.dataSource.forEach(function (itemData,idx) {
                    $("<div style='display:inline-block;width:" + option.widthVignette + "px;height:" + option.widthVignette + "px;margin:3px;' class='state-hover'/>").appendTo($DivLstFiles).css({
                        "background-image": "url('" + itemData.url + "?d=" + (new Date()).getTime() + "')",
                        "background-size": "cover",
                        "background-position": "center",
                        "background-repeat": "no-repeat"
                    }).on("click", function (e) {
                        e.stopPropagation()
                        $("<div style='position:absolute;top:0;left:0;'/>").appendTo("body").dxCtrlDisplayImgSimple({
                            bddCtrl: option.bddCtrl,
                            dataSource: option.dataSource,
                            index:idx
                        })
                    })
                })
                break;
        }
        mUpdataModifLstFile()

        $DivLstFiles.css("height", "")
    }

    function mUpdataModifLstFile() {
        if (typeof option.containerBtAdd != 'undefined' && option.dataSource.length == 0) {
            //le bt add file est ailleurs, on cache le ctrl si on a pas de fichier
            $DivLstFiles.hide()
        } else {
            $DivLstFiles.show()
        }
    }

    var dxCtrlFichierPopup = null;
    this.mShowVisu = function (itemData) {
        var dsFile = option.dataSource
        if (isInAppMobile()) dsFile = [itemData]
        dxCtrlFichierPopup = $("<div/>").appendTo(container).dxCtrlFichier2Popup({
            bddCtrl: option.bddCtrl,
            dataSource: dsFile,
            readOnly: option.readOnly,
            onReorder: function (itemData) {
                dxCtrlTagGallery.mRepaint()
                option.onReorder(itemData)
            },
            onDemandeAddFiles: function () {
                mGetNewFiles()
            },
            onDeleteFiles: function (lstItemDataToDel) {
                option.onDeleteFiles(lstItemDataToDel)
                dxCtrlTagGallery.mRepaint()
            },
            selectedItem: itemData,
            onHiding: function (e) {
                dxCtrlFichierPopup = null;
            }
        }).dxCtrlFichier2Popup("instance")
    }

    function mGetNewFiles() {
        $("<div/>").appendTo("body").dxCtrlFileUploaderPopup({
            bddCtrl: option.bddCtrl,
            accept: option.accept,
            multiple: true,
            machine: true,
            //imgInternet: ((option.bddCtrl.isExterne()) ? false : true),
            //box: ((option.bddCtrl.isExterne()) ? false : true),
            //icone: ((option.bddCtrl.isExterne()) ? false : true),
            //docCpt: ((option.bddCtrl.isExterne()) ? false : true),
            //courrier: ((option.bddCtrl.isExterne()) ? false : true),
            imgInternet: option.imgInternet,
            imgPexel: option.imgPexel,
            box: option.box,
            icone: option.icone,
            docCpt: option.docCpt,
            courrier: option.courrier,
            camera: false,
            selectedItem: "machine",
            onValide: function (lstUrlFile) {
                option.onAddFiles(lstUrlFile, function (lstNewItemData) {
                    if (dxCtrlFichierPopup) dxCtrlFichierPopup.mAddNewItemData(lstNewItemData)
                    dxCtrlTagGallery.mAddNewItemData(lstNewItemData)
                    mUpdataModifLstFile()
                })
            }
        }).dxCtrlFileUploaderPopup("instance")
        //var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupFileUploader({
        //    optionFileUploader: {
        //        allowDisplayIcone: option.allowDisplayIcone,
        //        maxFileSizeOctetImage: ((typeof option.maxFileSizeOctetImage == 'undefined') ? 10485760 : option.maxFileSizeOctetImage), //10 Mo
        //        maxFileSizeOctetFichier: ((typeof option.maxFileSizeOctetImage == 'undefined') ? 52428800 : option.maxFileSizeOctetImage), //50 Mo
        //        multiple: true,
        //        accept: option.accept,
        //        btCameraVisible: false,
        //        funcEndLoading: function (lstUrlFile) {
        //            if (lstUrlFile.length > 0) {
        //                var lstUrl = []
        //                lstUrlFile.forEach(function (file) { lstUrl.push(file.url) })
        //                option.onAddFiles(lstUrl, function (lstNewItemData) {
        //                    if (dxCtrlFichierPopup) dxCtrlFichierPopup.mAddNewItemData(lstNewItemData)
        //                    dxCtrlTagGallery.mAddNewItemData(lstNewItemData)
        //                    mUpdataModifLstFile()
        //                })
        //            }
        //            pop.hide();
        //        }
        //    },
        //    multiple: true
        //}).dxCtrlPopupFileUploader("instance")
        //pop.show();
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }
    //this.dispose = function () {

    //}

    mConstruit();
}